"use client";

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AlertDialog from "../components/AlertDialog";

export default function QuickBooksSuccess() {
  const navigate = useNavigate();

  const handleConfirm = () => {
    navigate("/"); // Redirect to root after confirming
  };

  useEffect(() => {
    // Optionally, you could fetch QuickBooks status here to confirm connection
  }, []);

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100 flex items-center justify-center">
      <AlertDialog
        type="success"
        title="Success"
        message="QuickBooks connected successfully!"
        confirmText="OK"
        cancelText="Close"
        open={true} // Always open when on this page
        onClose={handleConfirm} // Redirect on close
        onConfirm={handleConfirm} // Redirect on confirm
        showCopyButton={false}
      />
    </div>
  );
}
